<div class="static-content-container" *ngIf="config.content" [innerHTML]="staticContent | unsafeHtml"></div>